import {
  GET_DRIVER_PROFILE,
  GET_DRIVER_PROFILE_ERROR,
  CREATE_DRIVER_PROFILE_SUCCESS,
  CREATE_DRIVER_PROFILE_FAILED,
  CREATE_DRIVER_PROFILE_PENDING,
  EDIT_DRIVER_PROFILE_SUCCESS,
  EDIT_DRIVER_PROFILE_FAILED,
  EDIT_DRIVER_PROFILE_PENDING,
} from "../constants/DriverConstants";
import { history } from "../Root";
import Axios from "axios";
import { API_ROOT } from "../components/utils/api-config";
import { setAlert } from "./alertAction";
let token = "Bearer " + localStorage.getItem("token");
const auth = {
  headers: {
    Authorization: token,
  },
};
export const getDriverProfile = (id) => (dispatch) => {
  Axios.get(`${API_ROOT}/drivers/${id}/`, auth)
    .then((response) =>
      dispatch({ type: GET_DRIVER_PROFILE, payload: response.data })
    )
    .catch((error) =>
      dispatch({ type: GET_DRIVER_PROFILE_ERROR, payload: error })
    );
};
export const postDriver = (formData, config) => (dispatch) => {
  dispatch({ type: CREATE_DRIVER_PROFILE_PENDING });
  Axios.post(`${API_ROOT}/drivers/`, formData, auth, config)
    .then(({ data }) => {
      dispatch({
        type: CREATE_DRIVER_PROFILE_SUCCESS,
        payload: data,
      });
      dispatch(setAlert("Driver profile created", "success"));
      history.push(`/drivers/${data.id}`);
    })
    .catch((error) =>
      dispatch({ type: CREATE_DRIVER_PROFILE_FAILED, payload: error })
    );
};
export const editDriverProfile = (driver) => (dispatch) => {
  dispatch({ type: EDIT_DRIVER_PROFILE_SUCCESS, payload: driver });
  dispatch(setAlert("Driver profile changed", "success"));
};
